// Applies the partner font that the backend resolves server-side
// (see App\Services\MobilePassData::preparePartner). The payload includes
// styles.fontFamily and styles.fontGoogleHref, so the client does not need a
// copy of the Google Fonts catalogue.

const PARTNER_FONT_LINK_ID = 'partner-font-stylesheet';

const DEFAULT_FONT_FAMILY = 'open-sans, sans-serif';

export default function applyPartnerFont(styles) {
  const existing = document.getElementById(PARTNER_FONT_LINK_ID);
  if (existing) existing.remove();

  const family = styles?.fontFamily;
  const href = styles?.fontGoogleHref;

  if (!family) {
    document.documentElement.style.removeProperty('--partner-font-family');
    return DEFAULT_FONT_FAMILY;
  }

  document.documentElement.style.setProperty('--partner-font-family', family);

  if (href) {
    const link = document.createElement('link');
    link.id = PARTNER_FONT_LINK_ID;
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  return family;
}
